<div class="chat-wrapper">
  <div class="chat-history-container">
    <atlas-ai-chat-history-list
      (changeTab)="onChangeTab($event)"
    ></atlas-ai-chat-history-list>
  </div>
</div>
